const state = {
  modal: null,
};

const actions = {
  handleUserAction: async ({ state }) => {
    state.modal.userAction && (await state.modal.userAction());
  },
};

const getters = {
  modal: (state) => state.modal,
  modalData: (state) => state.modal.modalData,
};

const mutations = {
  createModal(state, modal) {
    state.modal = {
      ...modal,
      showModal: false,
    };
  },
  showModal(state, isOpen = true) {
    state.modal.showModal = isOpen;
  },
  async userAction(state, userAction) {
    state.modal.userAction = userAction;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
